import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for ForgotPasswordPage
 *
 */

const ForgotPasswordPage = lazyLoad(
  () => import('app/modules/Auth/ForgotPassword'),
  (module) => module.default,
);

export default ForgotPasswordPage;
